import clsx from "clsx";
import React from "react";

import { Checkbox } from "./Checkbox";
import * as styles from "./InputCheckbox.module.css";

export type InputCheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  completed?: boolean;
  widePadding?: boolean;
  nowrap?: boolean;
  checkboxPosition?: "left" | "center" | "right";
  "data-testid"?: string;
};

export const InputCheckbox: React.FC<InputCheckboxProps> = ({
  disabled,
  completed,
  widePadding,
  className,
  children,
  nowrap = true,
  checkboxPosition = "left",
  ...props
}) => (
  <label
    className={clsx(
      styles.container,
      disabled && styles.disabled,
      completed && styles.completed,
      nowrap && styles.nowrap,
      widePadding && styles.widePadding,
      checkboxPosition === "center" && "justify-center",
      checkboxPosition === "right" && "justify-end",
      className
    )}
    data-testid={props["data-testid"]}
  >
    <Checkbox disabled={disabled} completed={completed} {...props} data-testid={undefined} />
    {children && <span className={styles.label}>{children}</span>}
  </label>
);
